import goalsService from '@/services/goalsService.js'; 
import actionsService from '@/services/actionsService.js';
import generalService from '@/services/generalService';
import tasksService from '@/services/tasksService';
export default {
  state: () => ({
    activeTask: null,
    activeGoal: null,
    activeAction: null,
    sliderOpen: false,
    emailFields: null,
    prelimQuestions: null,
    docsTemplateId: null,
    googleDocsUrl: null,
    goals: null,
    actionTypes: {},
    connections: [],
    showFileUploadModal: false,
    showTaskEditModal: false,
    taskConversation: '',
    userData: {},

  }),
  mutations: {
    setUserData(state, data){
      state.userData = data;
    },
    setActiveTask(state, task) {
        state.activeTask = task;
    },
    setActiveGoal(state, goal) {
      state.activeGoal = goal;
    },
    setActiveAction(state,action){
      state.activeAction = action;
    },
    setSliderOpen(state, bool){
      state.sliderOpen = bool;
    },
    setEmailFields(state, form){
      state.emailFields = form;
    },
    setGoals(state, goals){
      state.goals = goals;
    },
    setGoogleDocsUrl(state, url){
      state.docsUrl = url;
    },
    setActionTypes(state, types){
      state.actionTypes = { ...types };
    },
    setConnections(state, connections){ 
      state.connections = connections;
    },
    setShowFileUploadModal(state,bool){
      state.showFileUploadModal = bool
    },
    setShowTaskEditModal(state,bool){
      state.showTaskEditModal = bool
    },
    setDocsTemplateId(state,id){
      state.docsTemplateId = id;
    },
    setPrelimQuestions(state,questions){
      state.prelimQuestions = questions;
    },
    setTaskConversation(state, guide){
      state.taskConversation = guide;
    }

  },
  actions: {
    async editTask({commit,dispatch,state,rootState}, {showModal, task}){
      if(task) {
        await tasksService.updateTask(task);
      }else{
        await tasksService.updateTask(state.activeTask);
      }
      commit('setShowTaskEditModal', showModal);
      dispatch('getGoals',rootState.projects.selectedProject.id);
    },
    setActiveGoal( {commit}, goal){
      commit('setActiveGoal', goal)
    },
    setActiveTaskGoalAction({commit}, payload){
      commit('setActiveTask', payload.task);
      commit('setActiveGoal', payload.goal)
      commit('setActiveAction', payload.action)
    },
    async addTaskToGoal({dispatch, rootState}, payload){
      await goalsService.addTaskToGoal(payload);
      dispatch('getGoals',rootState.projects.selectedProject.id);
    },

    setSliderState({commit}, payload){
        commit('setSliderOpen', payload);
    },
    setEmailFields({commit}, payload){
      commit('setEmailFields', payload);
    },
    setGoals({commit}, payload){
      commit('setGoals', payload);
    },
    async getGoals({commit}, project){
      let goals = await goalsService.getPreviousGoals(project);
      commit('setGoals', goals);

    },
    async getActionTypes({commit}){
      let actionTypes = await actionsService.getActionTypes();
       commit('setActionTypes', actionTypes);

    },
    setGoogleDocsUrl({commit}, payload){
      commit('setGoogleDocsUrl', payload);
    },
    async prelimQuestions({commit}, payload){
      commit('setSliderOpen', true);
      commit('setActiveTask', JSON.stringify(payload.task));
      commit('setActiveGoal', JSON.stringify(payload.goal))
      commit('setActiveAction', payload.action)

      let response = await actionsService.prelimQuestions(payload);
      if(response.docsTemplateId){
        commit('setDocsTemplateId', response.docsTemplateId);
      }
      commit('setPrelimQuestions', response.prelimQuestions);

    },
    async sendMessage({commit,state}, formData){
      commit('setSliderOpen', true);

      if (!formData || !(formData instanceof FormData)) {
        formData = new FormData();
      }

      formData.append('task', JSON.stringify(state.activeTask));
      formData.append('goal', JSON.stringify(state.activeGoal));
      formData.append('action', JSON.stringify(state.activeAction));
      let response = await actionsService.sendMessage(formData);
      commit('setTaskConversation', response.conversation);
    },
    async performAction({commit,state}, payload){
      commit('setSliderOpen', true);
      let response = await actionsService.performAction({task: state.activeTask, goal: state.activeGoal, action: state.activeAction, prelimQuestions: payload.prelimQuestions, templateId: state.docsTemplateId, message: payload.message});
      if(response.documentId){
        commit('setGoogleDocsUrl', `https://docs.google.com/document/d/${response.documentId}/edit`);
      }else if(response.emailFields){
        commit('setEmailFields', response.emailFields);
      }else if (state.activeAction == 'guide'){
        commit('setTaskConversation', response.conversation);
      }
    },
    async getInitData({commit}){
      let data = await generalService.getInitialData();
      commit('setConnections', data.connections)
      commit('setUserData', data.userData)
    },

    setShowFileUploadModal({commit}, bool){
      commit('setShowFileUploadModal', bool);
    },
    setShowTaskEditModal({commit}, bool){
      commit('setShowTaskEditModal', bool);
    },
  },
  getters: {
    activeTask: (state) => state.activeTask,
    activeGoal: (state) => state.activeGoal,
    activeAction: (state) => state.activeAction,
    sliderOpen: (state) => state.sliderOpen,
    emailFields: (state) => state.emailFields,
    goals: (state) => state.goals,
    googleDocsUrl: (state) => state.docsUrl,
    actionTypes: (state) => state.actionTypes,
    connections: (state) => state.connections,
    showFileUploadModal: (state) => state.showFileUploadModal,
    showTaskEditModal: (state) => state.showTaskEditModal,
    docsTemplateId: (state) => state.docsTemplateId,
    prelimQuestions: (state) => state.prelimQuestions,
    taskConversation: (state) => state.taskConversation,
    userData: (state) => state.userData,

  },
};
